import { appConfig } from '../../configs/env-config.js'

import * as apiConfig from './apiConfig.js'

const apiRoute = appConfig.REACT_APP_UrlApi
const apiRouteAuth = appConfig.REACT_APP_UrlApiAuth
const pageSizeDefault = 20

/////////////////////////////////////////////////////////////////////
// login
/////////////////////////////////////////////////////////////////////

export const login = async (login, password) => {
  const data = {
    username: login,
    rawPassword: password
  }
  return await apiConfig.sendWithAxios(`${apiRouteAuth}auth`, 'POST', data)
}

export const loginWithMfa = async (login, password, mfaType, mfaCode) => {
  const data = {
    username: login,
    rawPassword: password,
    mfaType: mfaType,
    mfaCode: mfaCode
  }
  return await apiConfig.sendWithAxios(`${apiRouteAuth}auth/mfa`, 'POST', data)
}

export const getTotpConfiguration = async (login, password) => {
  const data = {
    username: login,
    rawPassword: password
  }
  return await apiConfig.sendWithAxios(`${apiRouteAuth}auth/mfa/totp/requestconfig`, 'POST', data)
}

export const finishTotpConfiguration = async (login, password, key, code) => {
  const data = {
    username: login,
    rawPassword: password,
    key: key,
    totpCode: code
  }
  return await apiConfig.sendWithAxios(`${apiRouteAuth}auth/mfa/totp/setconfig`, 'POST', data)
}

export const requestMfaEmailCode = async (username) => {
  const data = {
    username: username
  }
  return await apiConfig.sendWithAxios(`${apiRouteAuth}auth/mfa/requestemail`, 'POST', data)
}

export const recoveryRequest = async (username) => {
  const data = {
    username
  }
  return await apiConfig.sendWithAxios(`${apiRouteAuth}auth/startrecovery`, 'POST', data)
}

export const changePasswordByEmail = async (email, secret, secretId, newPassword) => {
  const data = {
    username: email,
    secret: secret,
    secretId: secretId,
    newPassword: newPassword
  }
  return await apiConfig.sendWithAxios(`${apiRouteAuth}auth/recoverypassword`, 'POST', data)
}

export const changePasswordExpired = async (email, newPassword, oldSenha) => {
  const data = {
    username: email,
    rawPassword: oldSenha,
    newPassword: newPassword
  }
  return await apiConfig.sendWithAxios(`${apiRouteAuth}auth/resetpassword`, 'POST', data)
}

/////////////////////////////////////////////////////////////////////
// environment
/////////////////////////////////////////////////////////////////////

export const environmentsRelatedAll = async () => {
  return await apiConfig.sendWithAxios(
    `${apiRoute}environments/all/related`,
    'GET'
  )
}

export const getEnvironmentById = async (id) => {
  return await apiConfig.sendWithAxios(
    `${apiRoute}environments/${id}`,
    'GET'
  )
}

export const getEnvironmentsAll = async () => {
  return await apiConfig.sendWithAxios(
    `${apiRoute}environments/all`,
    'GET'
  )
}

export const getAllEnvGroups = async (envId) => {
  return await apiConfig.sendWithAxios(
    `${apiRoute}environments/${envId}/groups/all`,
    'GET'
  )
}

export const getEnvOverview = async (envId) => {
  return await apiConfig.sendWithAxios(
    `${apiRoute}environments/${envId}/overview`,
    'GET'
  )
}

export const criarEnvironment = async (name) => {
  const data = {
    name: name
  }
  return await apiConfig.sendWithAxios(
    `${apiRoute}environments`,
    'POST',
    data
  )
}
export const editarEnvironment = async (name, id) => {
  const data = {
    name: name,
    id: id
  }
  return await apiConfig.sendWithAxios(
    `${apiRoute}environments`,
    'PUT',
    data
  )
}

export const addEnvGroup = async (name, id) => {
  const data = {
    name: name,
    order: 0,
    environmentId: id
  }
  return await apiConfig.sendWithAxios(
    `${apiRoute}environments/group`,
    'POST',
    data
  )
}

export const updateEnvGroup = async (name, id) => {
  const data = {
    name: name,
    id: id
  }
  return await apiConfig.sendWithAxios(
    `${apiRoute}environments/group`,
    'PUT',
    data
  )
}

export const deleteEnvGroup = async (id) => {
  return await apiConfig.sendWithAxios(
    `${apiRoute}environments/group/${id}`,
    'DELETE'
  )
}

export const setGroupOrder = async (data) => {
  return await apiConfig.sendWithAxios(
    `${apiRoute}environments/group/setorder`,
    'PUT',
    data
  )
}

export const addFilterToDashboard = async (data) => {
  return await apiConfig.sendWithAxios(
    `${apiRoute}dashboards/filters`,
    'POST',
    data
  )
}

export const updateFilterToDashboard = async (data) => {
  return await apiConfig.sendWithAxios(
    `${apiRoute}dashboards/filters`,
    'PUT',
    data
  )
}

export const addDashboardUsers = async (data, dashboardGroupId) => {
  return await apiConfig.sendWithAxios(
    `${apiRoute}dashboards/access/user/dashboardgroup/${dashboardGroupId}`,
    'PUT',
    data
  )
}

export const addDashboardTeams = async (data, dashboardGroupId) => {
  return await apiConfig.sendWithAxios(
    `${apiRoute}dashboards/access/team/dashboardgroup/${dashboardGroupId}`,
    'PUT',
    data
  )
}

export const removeFilterFromDashboard = async (id) => {
  return await apiConfig.sendWithAxios(
    `${apiRoute}dashboards/filters/${id}`,
    'DELETE'
  )
}

export const removeUserFromDashboardGroup = async (id) => {
  return await apiConfig.sendWithAxios(
    `${apiRoute}dashboards/access/user/${id}`,
    'DELETE'
  )
}

export const removeTeamFromDashboardGroup = async (id) => {
  return await apiConfig.sendWithAxios(
    `${apiRoute}dashboards/access/team/${id}`,
    'DELETE'
  )
}


export const deleteEnvironment = async (id) => {
  return await apiConfig.sendWithAxios(
    `${apiRoute}environments/${id}`,
    'DELETE'
  )
}

export const getDashboardById = async (id) => {
  return await apiConfig.sendWithAxios(
    `${apiRoute}dashboards/${id}`,
    'GET'
  )
}

export const getDashboardEnvOverview = async (id) => {
  return await apiConfig.sendWithAxios(
    `${apiRoute}dashboards/${id}/envoverview`,
    'GET'
  )
}

export const addDashboardGroup = async (dashboardId, groupId) => {
  return await apiConfig.sendWithAxios(
    `${apiRoute}dashboards/${dashboardId}/group/${groupId}`,
    'POST'
  )
}

export const updateDashboardGroupGroup = async (dashboardGroupId, groupId) => {
  return await apiConfig.sendWithAxios(
    `${apiRoute}dashboards/dashboardgroupid/${dashboardGroupId}/group/${groupId}`,
    'PUT'
  )
}

export const updateDashboardGroupAiAgent = async (dashboardGroupId, agentId) => {
  return await apiConfig.sendWithAxios(
    `${apiRoute}dashboards/dashboardgroupid/${dashboardGroupId}/agent/${agentId}`,
    'PUT'
  )
}

export const updateDashboardGroupRule = async (dashboardGroupId, ruleId) => {
  return await apiConfig.sendWithAxios(
    `${apiRoute}dashboards/dashboardgroupid/${dashboardGroupId}/rule/${ruleId}`,
    'PUT'
  )
}

export const deleteDashboardGroup = async (dashboardId, groupId) => {
  return await apiConfig.sendWithAxios(
    `${apiRoute}dashboards/${dashboardId}/group/${groupId}`,
    'DELETE'
  )
}

export const getAllUsersFromDashGroupId = async (dashboardGroupId) => {
  return await apiConfig.sendWithAxios(
    `${apiRoute}dashboards/access/user/dashboardgroup/${dashboardGroupId}`,
    'GET'
  )
}

export const getAllTeamsFromDashGroupId = async (dashboardGroupId) => {
  return await apiConfig.sendWithAxios(
    `${apiRoute}dashboards/access/team/dashboardgroup/${dashboardGroupId}`,
    'GET'
  )
}


export const getDashboardAll = async (params, page = 1, pageSize = pageSizeDefault) => {
  const { orderByColumn, desc, adicionalQuery, filterBy, filterValue } = params
  let pagination = `${page}/${pageSize}`
  let queryComplement = adicionalQuery ? adicionalQuery : ''
  if (orderByColumn && !desc) {
    queryComplement += `${queryComplement ? '&' : '?'}orderBy=${orderByColumn}`
  }
  if (orderByColumn && desc) {
    queryComplement += `${queryComplement ? '&' : '?'}orderByDesc=${orderByColumn}`
  }
  if (filterBy && filterValue) {
    queryComplement += `${queryComplement ? '&' : '?'}${filterBy}=${filterValue}`
  }
  return await apiConfig.sendWithAxios(
    `${apiRoute}dashboards/all/paged/${pagination}${queryComplement}`,
    'GET'
  )
}

export const getDashboardAllRelated = async (params, page = 1, pageSize = pageSizeDefault) => {
  const { orderByColumn, desc, adicionalQuery, filterBy, filterValue } = params
  let pagination = `${page}/${pageSize}`
  let queryComplement = adicionalQuery ? adicionalQuery : ''
  if (orderByColumn && !desc) {
    queryComplement += `${queryComplement ? '&' : '?'}orderBy=${orderByColumn}`
  }
  if (orderByColumn && desc) {
    queryComplement += `${queryComplement ? '&' : '?'}orderByDesc=${orderByColumn}`
  }
  if (filterBy && filterValue) {
    queryComplement += `${queryComplement ? '&' : '?'}${filterBy}=${filterValue}`
  }
  return await apiConfig.sendWithAxios(
    `${apiRoute}dashboards/all/related/paged/${pagination}${queryComplement}`,
    'GET'
  )
}

export const getDashboardByEmpresa = async (empresaId, page = 1, dashboardName, coluna, desc, pageSize = pageSizeDefault) => {
  let query = `?page=${page}&pageSize=${pageSize}`
  if (dashboardName) {
    query += `&dashboardName=${dashboardName}`
  }
  if (coluna) {
    query += `&orderBy=${coluna}`
  }
  if (desc) {
    query += `&descending=${desc}`
  }
  return await apiConfig.sendWithAxios(
    `${apiRoute}dashboards/all/environment/${empresaId}/paged${query}`,
    'GET'
  )
}

export const dashboardgroupsByEnvironment = async (idEnvironment) => {
  return await apiConfig.sendWithAxios(
    `${apiRoute}dashboardgroups/all/environment/${idEnvironment}`,
    'GET'
  )
}

export const dashboardgroupsRelatedByEnvironment = async (idEnvironment) => {
  return await apiConfig.sendWithAxios(
    `${apiRoute}environments/${idEnvironment}/related`,
    'GET'
  )
}

export const criarDashboard = async (data) => {
  if (data.autoRefreshTime === '') {
    data.autoRefreshTime = null
  }
  if (data.order === '') {
    data.order = null
  }
  return await apiConfig.sendWithAxios(
    `${apiRoute}dashboards`,
    'POST',
    data
  )
}

export const editDashboard = async (data) => {
  if (data.AutoRefreshTime === '') {
    data.AutoRefreshTime = null
  }
  if (data.Order === '' || undefined) {
    data.Order = null
  }
  return await apiConfig.sendWithAxios(
    `${apiRoute}dashboards`,
    'PUT',
    data
  )
}

export const setDashboardFilterOrder = async (data) => {
  return await apiConfig.sendWithAxios(
    `${apiRoute}dashboards/filters/setorder`,
    'PUT',
    data
  )
}

export const getGrupoById = async (idGrupo) => {
  return await apiConfig.sendWithAxios(
    `${apiRoute}dashboardgroups/${idGrupo}`,
    'GET'
  )
}

export const criarGrupo = async (data) => {
  return await apiConfig.sendWithAxios(
    `${apiRoute}dashboardgroups`,
    'POST',
    data
  )
}

export const deleteGrupo = async (id) => {
  return await apiConfig.sendWithAxios(
    `${apiRoute}dashboardgroups/${id}`,
    'DELETE'
  )
}

export const editGrupo = async (data) => {
  return await apiConfig.sendWithAxios(
    `${apiRoute}dashboardgroups`,
    'PUT',
    data
  )
}

export const powerbiKey = async (dashboardId, envId) => {
  return await apiConfig.sendWithAxios(
    `${apiRoute}powerbi/token/${dashboardId}/${envId}`,
    'GET'
  )
}


export const getTeamsAllRelated = async () => {
  return await apiConfig.sendWithAxios(
    `${apiRoute}teams/all/related`,
    'GET'
  )
}

export const getTeamsAll = async () => {
  return await apiConfig.sendWithAxios(
    `${apiRoute}teams/all`,
    'GET'
  )
}

export const getAllTeamsPaged = async (params, page = 1, pageSize = pageSizeDefault) => {
  const { search, orderByColuna, desc, filterBy, filterValue } = params
  let query = `${page}/${pageSize}`
  let queryComplement = ''
  if (search) {
    queryComplement += `${queryComplement ? '&' : '?'}${search}`
  }
  if (orderByColuna && !desc) {
    queryComplement += `${queryComplement ? '&' : '?'}orderBy=${orderByColuna}`
  }
  if (orderByColuna && desc) {
    queryComplement += `${queryComplement ? '&' : '?'}orderByDesc=${orderByColuna}`
  }
  if (filterBy && filterValue) {
    queryComplement += `${queryComplement ? '&' : '?'}${filterBy}=${filterValue}`
  }
  return await apiConfig.sendWithAxios(
    `${apiRoute}teams/all/paged/${query}${queryComplement}`,
    'GET'
  )
}


// export const getUsersAllAdmins = async () => {
//   return await apiConfig.sendWithAxios(
//     `${apiRoute}users/customeradmins/all`,
//     'GET'
//   )
// }

export const getUsersAll = async (params, page = 1, pageSize = pageSizeDefault) => {
  const { orderByColumn, desc, adicionalQuery, filterBy, filterValue } = params
  let pagination = `${page}/${pageSize}`
  let queryComplement = adicionalQuery ? adicionalQuery : ''

  if (orderByColumn && !desc) {
    queryComplement += `${queryComplement ? '&' : '?'}orderBy=${orderByColumn}`
  }
  if (orderByColumn && desc) {
    queryComplement += `${queryComplement ? '&' : '?'}orderByDesc=${orderByColumn}`
  }
  if (filterBy && filterValue) {
    queryComplement += `${queryComplement ? '&' : '?'}${filterBy}=${filterValue}`
  }
  return await apiConfig.sendWithAxios(
    `${apiRoute}users/all/paged/${pagination}${queryComplement}`,
    'GET'
  )
}

export const getUsersAllRelated = async (params, page = 1, pageSize = pageSizeDefault) => {
  const { orderByColumn, desc, adicionalQuery, filterBy, filterValue } = params
  let pagination = `${page}/${pageSize}`
  let queryComplement = adicionalQuery ? adicionalQuery : ''

  if (orderByColumn && !desc) {
    queryComplement += `${queryComplement ? '&' : '?'}orderBy=${orderByColumn}`
  }
  if (orderByColumn && desc) {
    queryComplement += `${queryComplement ? '&' : '?'}orderByDesc=${orderByColumn}`
  }
  if (filterBy && filterValue) {
    queryComplement += `${queryComplement ? '&' : '?'}${filterBy}=${filterValue}`
  }
  return await apiConfig.sendWithAxios(
    `${apiRoute}users/all/related${queryComplement}`,
    'GET'
  )
}

export const getUsersByEquipe = async (params, page = 1, idEquipe, pageSize = pageSizeDefault) => {
  const { orderByColumn, desc, adicionalQuery, filterBy, filterValue } = params
  let pagination = `${page}/${pageSize}`
  let queryComplement = adicionalQuery ? adicionalQuery : ''
  if (orderByColumn && !desc) {
    queryComplement += `${queryComplement ? '&' : '?'}orderBy=${orderByColumn}`
  }
  if (orderByColumn && desc) {
    queryComplement += `${queryComplement ? '&' : '?'}orderByDesc=${orderByColumn}`
  }
  if (filterBy && filterValue) {
    queryComplement += `${queryComplement ? '&' : '?'}${filterBy}=${filterValue}`
  }
  return await apiConfig.sendWithAxios(
    `${apiRoute}teams/${idEquipe}/members/all/paged/${pagination}${queryComplement}`,
    'GET'
  )
}


export const criarUsuario = async (user) => {
  let data = {
    name: user.name,
    username: user.username,
    email: user.email,
    company: user.company,
    internal: user.internal,
    role: user.role,
    password: user.password,
    expirationDays: user.expirationDays > 0 ? user.expirationDays : null,
    updatePasswordOnLogin: user.updatePasswordOnLogin
  }
  if (user.phone) {
    data.phone = user.phone
  }
  return await apiConfig.sendWithAxios(
    `${apiRoute}users`,
    'POST',
    data
  )
}

export const editUsuario = async (user) => {
  let data = {
    id: user.id,
    name: user.name,
    username: user.username,
    email: user.email,
    company: user.company,
    internal: user.internal,
    role: user.role,
    expirationDays: user.expirationDays > 0 ? user.expirationDays : null,
    updatePasswordOnLogin: user.updatePasswordOnLogin
  }
  data.active = user.active
  if (user.phone) {
    data.phone = user.phone
  }
  return await apiConfig.sendWithAxios(
    `${apiRoute}users`,
    'PUT',
    data
  )
}

export const editUsuarioMe = async (user, oldSenha) => {
  let data = {
    username: user.email,
    rawPassword: oldSenha,
    newPassword: user.password
  }
  return await apiConfig.sendWithAxios(
    `${apiRouteAuth}auth/resetpassword`,
    'POST',
    data
  )
}
export const editSenha = async (password) => {
  let data = {
    password
  }
  return await apiConfig.sendWithAxios(
    `${apiRoute}users/me/newpassword`,
    'PUT',
    data
  )
}


export const criarEquipe = async (name) => {
  const data = {
    name: name
  }
  return await apiConfig.sendWithAxios(
    `${apiRoute}teams`,
    'POST',
    data
  )
}
export const vicularUsuarioComEquipe = async (userId, equipeId) => {
  const data = {
    userId: userId,
    teamId: equipeId
  }
  return await apiConfig.sendWithAxios(
    `${apiRoute}teams/members`,
    'POST',
    data
  )
}
export const vicularUsuarioComEquipeMult = async (data) => {
  return await apiConfig.sendWithAxios(
    `${apiRoute}teams/members/multi`,
    'POST',
    data
  )
}
export const vicularUsuarioAdminComDash = async (userId, empresaId) => {
  return await apiConfig.sendWithAxios(
    `${apiRoute}environments/${empresaId}/admins/${userId}`,
    'PUT'
  )
}
export const desvicularUsuarioAdminComDash = async (userId, empresaId) => {
  return await apiConfig.sendWithAxios(
    `${apiRoute}environments/${empresaId}/admins/${userId}`,
    'DELETE'
  )
}
export const editarEquipe = async (name, id) => {
  const data = {
    name: name,
    id: id
  }
  return await apiConfig.sendWithAxios(
    `${apiRoute}teams`,
    'PUT',
    data
  )
}
export const deleteEquipe = async (id) => {
  return await apiConfig.sendWithAxios(
    `${apiRoute}teams/${id}`,
    'DELETE'
  )
}

export const inativeUsers = async (listOfUsersIds) => {
  const data = listOfUsersIds
  return await apiConfig.sendWithAxios(
    `${apiRoute}users/inactivate`,
    'PUT',
    data
  )
}

export const deleteUsersLote = async (
  usuarios
) => {
  const retExclusao = await Promise.all(
    usuarios.map(async user => {
      return apiConfig.sendWithAxios(`${apiRoute}users/${user.id}`, 'DELETE')
    })
  )
  const error = retExclusao.filter(x => x.fail)
  if (error.length) {
    return {
      fail: true,
      data: null,
      errors: { Message: usuarios.length > 1 ? 'Um ou mais usuários não puderam ser removidos' : 'Não foi possível remover o usuário' }
    }
  }
  const formatExclusao = {
    fail: false,
    data: retExclusao.map(x => {
      return x.data
    })
  }
  return formatExclusao
}

export const removerUsersEquipeLote = async (
  teamId,
  usuarios
) => {
  const retRemover = await Promise.all(
    usuarios.map(async user => {
      return apiConfig.sendWithAxios(`${apiRoute}teams/${teamId}/${user.id}`, 'DELETE')
    })
  )
  const error = retRemover.filter(x => x.fail)
  if (error.length) {
    return {
      fail: true,
      data: null,
      errors: { Message: usuarios.length > 1 ? 'Um ou mais usuários não puderam ser removidos' : 'Não foi possível remover o usuário' }
    }
  }
  const formatRemover = {
    fail: false,
    data: retRemover.map(x => {
      return x.data
    })
  }
  return formatRemover
}

export const ativeDashLote = async (
  dashboards
) => {
  return await apiConfig.sendWithAxios(
    `${apiRoute}dashboards/activate`,
    'PUT',
    dashboards
  )
}

export const deleteDashboard = async (
  dashboardId
) => {
  return await apiConfig.sendWithAxios(
    `${apiRoute}dashboards/${dashboardId}`,
    'DELETE'
  )
}

export const dashEditOrder = async (
  dashId,
  newOrder
) => {
  return await apiConfig.sendWithAxios(
    `${apiRoute}dashboards/${dashId}/order/${newOrder}`,
    'PUT'
  )
}

export const inativeDashLote = async (
  dashboards
) => {
  return await apiConfig.sendWithAxios(
    `${apiRoute}dashboards/inactivate`,
    'PUT',
    dashboards
  )
}

export const deleteDashboardsLote = async (
  dashboards
) => {
  const retExclusao = await Promise.all(
    dashboards.map(async user => {
      return apiConfig.sendWithAxios(`${apiRoute}dashboards/${user.id}`, 'DELETE')
    })
  )
  const error = retExclusao.filter(x => x.fail)
  if (error.length) {
    return {
      fail: true,
      data: null,
      errors: { Message: dashboards.length > 1 ? 'Um ou mais dashboards não puderam ser removidos' : 'Não foi possível remover o dashboards' }
    }
  }
  const formatExclusao = {
    fail: false,
    data: retExclusao.map(x => {
      return x.data
    })
  }
  return formatExclusao
}
export const isadmin = async (idEmpresa) => {
  return await apiConfig.sendWithAxios(
    `${apiRoute}environments/${idEmpresa}/isadmin/me`,
    'GET'
  )
}

export const getDetalheDash = async (id) => {
  return await apiConfig.sendWithAxios(
    `${apiRoute}dashboards/${id}`,
    'GET'
  )
}
export const getUserMe = async () => {
  return await apiConfig.sendWithAxios(
    // `${apiRouteAuth}users/me`,
    `${apiRoute}users/me`,
    'GET'
  )
}
export const getDetalheDashRelated = async (id) => {
  return await apiConfig.sendWithAxios(
    `${apiRoute}dashboards/related/${id}`,
    'GET'
  )
}

export const vincularUserDash = async (dashId, userId) => {
  return await apiConfig.sendWithAxios(
    `${apiRoute}dashboards/${dashId}/users/${userId}`,
    'PUT'
  )
}

export const vincularEquipeDash = async (dashId, equipeId) => {
  return await apiConfig.sendWithAxios(
    `${apiRoute}dashboards/${dashId}/teams/${equipeId}`,
    'PUT'
  )
}

export const desvincularUserDash = async (dashId, userId) => {
  return await apiConfig.sendWithAxios(
    `${apiRoute}dashboards/${dashId}/users/${userId}`,
    'DELETE'
  )
}

export const desvincularEquipeDash = async (dashId, equipeId) => {
  return await apiConfig.sendWithAxios(
    `${apiRoute}dashboards/${dashId}/teams/${equipeId}`,
    'DELETE'
  )
}

export const getIsEnvironmentOnRpaAutomatorList = async (id) => {
  return await apiConfig.sendWithAxios(
    `${apiRoute}rpaautomator/environment/${id}`,
    'GET'
  )
}

export const startRpaReprocess = async (dashboardId, year, month) => {
  return await apiConfig.sendWithAxios(
    `${apiRoute}rpaautomator/reprocess/dashboard/${dashboardId}/${year}/${month}`,
    'POST'
  )
}

export const dashboardCompaniesAll = async () => {
  return await apiConfig.sendWithAxios(
    `${apiRoute}dashboardcompanies/all`,
    'GET'
  )
}

/////////////////////////////////////////////////////////////////////
// Clientes
/////////////////////////////////////////////////////////////////////

export const getEmpresasMe = async () => {
  return await apiConfig.sendWithAxios(
    `${apiRoute}branchusermaps/all/me`,
    'GET'
  )
}

export const getLocais = async (temporary) => {
  let query = ''
  if (temporary) {
    query = '?temporary=true'
  }
  return await apiConfig.sendWithAxios(
    `${apiRoute}recruitmentCustomerUserMaps/all/me${query}`,
    'GET'
  )
}

export const tipoContrato = async () => {
  return await apiConfig.sendWithAxios(
    `${apiRoute}recruitmentCustomerUserMaps/allcontracts/me`,
    'GET'
  )
}

export const getComptradeEstById = async (id) => {
  return await apiConfig.sendWithAxios(
    `${apiRoute}comptrade/est/id/${id}`,
    'GET'
  )
}

export const getComptradeChannels = async (type) => {
  return await apiConfig.sendWithAxios(
    `${apiRoute}comptrade/est/attributes/all?type=${type}`,
    'GET'
  )
}

export const addComptradeChannel = async (data) => {
  return await apiConfig.sendWithAxios(
    `${apiRoute}comptrade/est/attributes`,
    'POST', data
  )
}

export const refreshEstFederalData = async (id) => {
  return await apiConfig.sendWithAxios(
    `${apiRoute}comptrade/est/id/${id}/refresh`,
    'PUT'
  )
}

export const aproveComptradeEst = async (id) => {
  return await apiConfig.sendWithAxios(
    `${apiRoute}comptrade/est/id/${id}`,
    'PUT'
  )
}

export const updateComptradeEst = async (data) => {
  return await apiConfig.sendWithAxios(
    `${apiRoute}comptrade/est`,
    'PUT', data
  )
}

export const getComptradeEstPaged = async (page = 1, pageSize = pageSizeDefault, orderBy = 'id', commonSearch, overviewFilter, desc = false) => {
  let params = ''
  let pagination = `${page}/${pageSize}`
  if (orderBy !== undefined) {
    if (desc)
      params += '?orderBy=' + orderBy
    else
      params += '?orderByDesc=' + orderBy
  }
  if (commonSearch !== undefined) {
    if (params !== '') {
      if (commonSearch !== '')
        params += '&commonSearch=' + commonSearch
    }
  }
  if (overviewFilter !== undefined) {
    if (params === '')
      params += '?' + overviewFilter
    else
      params += '&' + overviewFilter
  }

  return await apiConfig.sendWithAxios(
    `${apiRoute}comptrade/est/paged/${pagination}${params}`,
    'GET'
  )
}


export const getDashboardRulesPaged = async (page = 1, pageSize = pageSizeDefault, orderBy = 'id', commonSearch, desc = false) => {
  let params = ''
  let pagination = `${page}/${pageSize}`
  if (orderBy !== undefined) {
    if (desc)
      params += '?orderBy=' + orderBy
    else
      params += '?orderByDesc=' + orderBy
  }
  if (commonSearch !== undefined) {
    if (params !== '') {
      if (commonSearch !== '')
        params += '&commonSearch=' + commonSearch
    }
  }

  return await apiConfig.sendWithAxios(
    `${apiRoute}dashboardrules/all/paged/${pagination}${params}`,
    'GET'
  )
}

export const getAiAgentsPaged = async (page = 1, pageSize = pageSizeDefault, orderBy = 'id', commonSearch, desc = false) => {
  let params = ''
  let pagination = `${page}/${pageSize}`
  if (orderBy !== undefined) {
    if (desc)
      params += '?orderBy=' + orderBy
    else
      params += '?orderByDesc=' + orderBy
  }
  if (commonSearch !== undefined) {
    if (params !== '') {
      if (commonSearch !== '')
        params += '&commonSearch=' + commonSearch
    }
  }

  return await apiConfig.sendWithAxios(
    `${apiRoute}ai/agents/paged/${pagination}${params}`,
    'GET'
  )
}

export const getAllAgents = async () => {
  return await apiConfig.sendWithAxios(
    `${apiRoute}ai/agents`,
    'GET'
  )
}

export const getAllDashboardRules = async () => {
  return await apiConfig.sendWithAxios(
    `${apiRoute}dashboardrules/all`,
    'GET'
  )
}

export const getDashboardFilterRulesPaged = async (page = 1, pageSize = pageSizeDefault, orderBy = 'id', commonSearch, searchParam, desc = false, id) => {
  let params = '?DashboardRuleId=' + id
  let pagination = `${page}/${pageSize}`
  if (orderBy !== undefined) {
    if (desc)
      params += '&orderBy=' + orderBy
    else
      params += '&orderByDesc=' + orderBy
  }
  if (commonSearch !== undefined) {
    if (params !== '') {
      if (commonSearch !== '')
        params += '&' + searchParam + '=' + commonSearch
    }
  }

  return await apiConfig.sendWithAxios(
    `${apiRoute}dashboardrules/filterrule/all/paged/${pagination}${params}`,
    'GET'
  )
}

export const getDashboardRule = async (id) => {
  return await apiConfig.sendWithAxios(
    `${apiRoute}dashboardrules/${id}`,
    'GET'
  )
}

export const getAgent = async (id) => {
  return await apiConfig.sendWithAxios(
    `${apiRoute}ai/agents/${id}`,
    'GET'
  )
}

export const getAgentCanBeUsed = async (dashId, envId) => {
  return await apiConfig.sendWithAxios(
    `${apiRoute}ai/agents/can-prompt/environment/${envId}/dashboard/${dashId}`,
    'GET'
  )
}

export const getDashboardFilterRule = async (id) => {
  return await apiConfig.sendWithAxios(
    `${apiRoute}dashboardrules/filterrule/id/${id}`,
    'GET'
  )
}

export const deleteDashboardFilterRule = async (id) => {
  return await apiConfig.sendWithAxios(
    `${apiRoute}dashboardrules/filterrule/id/${id}`,
    'DELETE'
  )
}

export const createNewDashboardRule = async (item) => {
  return await apiConfig.sendWithAxios(
    `${apiRoute}dashboardrules`,
    'POST',
    item
  )
}

export const createNewAiAgent = async (item) => {
  return await apiConfig.sendWithAxios(
    `${apiRoute}ai/agents`,
    'POST',
    item
  )
}

export const updateAiAgent = async (item) => {
  return await apiConfig.sendWithAxios(
    `${apiRoute}ai/agents`,
    'PUT',
    item
  )
}

export const sendAiAgentPrompt = async (item) => {
  return await apiConfig.sendWithAxios(
    `${apiRoute}ai/agents/execute-prompt`,
    'POST',
    item
  )
}


export const createNewDashboardRuleItem = async (item) => {
  return await apiConfig.sendWithAxios(
    `${apiRoute}dashboardrules/item`,
    'POST',
    item
  )
}

export const updateDashboardRuleItem = async (item) => {
  return await apiConfig.sendWithAxios(
    `${apiRoute}dashboardrules/item`,
    'PUT',
    item
  )
}

export const updateDashboardRule = async (item) => {
  return await apiConfig.sendWithAxios(
    `${apiRoute}dashboardrules`,
    'PUT',
    item
  )
}

export const deleteDashboardRule = async (id) => {
  return await apiConfig.sendWithAxios(
    `${apiRoute}dashboardrules/id/${id}`,
    'DELETE'
  )
}

export const deleteAiAgent = async (id) => {
  return await apiConfig.sendWithAxios(
    `${apiRoute}ai/agents/${id}`,
    'DELETE'
  )
}



export const getEstOverview = async () => {
  return await apiConfig.sendWithAxios(
    `${apiRoute}comptrade/est/overview`,
    'GET'
  )
}

export const createNewEstItem = async (estItem) => {
  return await apiConfig.sendWithAxios(
    `${apiRoute}comptrade/est`,
    'POST',
    estItem
  )
}


export const recruitmentCustomerUserMe = async () => {
  return await apiConfig.sendWithAxios(
    `${apiRoute}recruitmentCustomerUserMaps/all/me`,
    'GET'
  )
}


export const getNotificationsRead = async () => {
  return await apiConfig.sendWithAxios(
    `${apiRoute}notifications/readed`,
    'GET'
  )
}

export const getNotificationsUnread = async () => {
  return await apiConfig.sendWithAxios(
    `${apiRoute}notifications/unreaded`,
    'GET'
  )
}

export const getNotificationsAll = async () => {
  return await apiConfig.sendWithAxios(
    `${apiRoute}notifications/all`,
    'GET'
  )
}

export const readNotifications = async (data) => {
  return await apiConfig.sendWithAxios(
    `${apiRoute}notifications/setreaded`,
    'PUT',
    data
  )
}

export const removeUserFromTeam = async (teamId, userId) => {
  return await apiConfig.sendWithAxios(
    `${apiRoute}teams/${teamId}/${userId}`,
    'DELETE'
  )
}

export const getTeamsByUser = async (userId) => {
  return await apiConfig.sendWithAxios(
    `${apiRoute}teams/user/${userId}`,
    'GET'
  )
}

export const alterarSenhaUser = async (userId, password) => {
  const data = {
    Password: password
  }
  return await apiConfig.sendWithAxios(
    `${apiRoute}users/${userId}/newpassword`,
    'PUT',
    data
  )
}

// TRCT METHODS

export const uploadTrct = async (file, fileType) => {
  // Cria um FormData com o nome do arquivo
  const formData = new FormData()
  formData.append('frontFileName', file.name)
  formData.append('fileType', fileType)

  try {
    // Solicita o link de upload do backend
    const response = await apiConfig.sendWithAxios(
      `${apiRoute}trct/uploadlink`,
      'POST',

      formData
    )

    return response.data

  } catch (error) {
    console.error('There was an error uploading the file!', error)
    throw error
  }
}

export const uploadSingleTrct = async (file, fileType, cpf) => {
  // Cria um FormData com o nome do arquivo
  const formData = new FormData()
  formData.append('frontFileName', file.name)
  formData.append('fileType', fileType)
  formData.append('cpf', cpf)


  try {
    // Solicita o link de upload do backend
    const response = await apiConfig.sendWithAxios(
      `${apiRoute}trct/uploadlinksingle`,
      'POST',

      formData
    )

    return response.data

  } catch (error) {
    console.error('There was an error uploading the file!', error)
    throw error
  }
}


export const uploadS3 = async (file, uploadUrl) => {

  const newFormData = new FormData()
  console.log(file)
  newFormData.append('fileName', file.name)

  await apiConfig.sendWithAxiosBlob(
    uploadUrl,
    'PUT',
    file
  )

}
export const triggerWorker = async (file) => {

  const newFormData = new FormData()
  console.log(file)
  newFormData.append('fileName', file.name)

  await apiConfig.sendWithAxios(
    `${apiRoute}trct/worker`,
    'POST',
    newFormData
  )
}

export const deleteFile = async (folder, fileName) => {
  await apiConfig.sendWithAxios(
    `${apiRoute}trct/deletefile`,
    'POST',
    {
      Folder: folder,
      FileName: fileName
    }
  )
}
export const deleteDocument = async (folder, fileName) => {
  await apiConfig.sendWithAxios(
    `${apiRoute}trct/deletedocument`,
    'POST',
    {
      Folder: folder,
      FileName: fileName
    }
  )
}

export const downloadTrct = async (fileName, folder) => {
  const formData = new FormData()
  fileName = folder + fileName
  formData.append('fileName', fileName)
  try {
    const response = await apiConfig.sendWithAxios(
      `${apiRoute}trct/downloadlink`,
      'POST',
      formData
    )

    const downloadUrl = response.data.url

    const link = document.createElement('a')
    link.href = downloadUrl
    link.download = fileName
    document.body.appendChild(link)
    link.target = '_blank'
    link.click()
    document.body.removeChild(link)
  } catch (error) {
    console.error('There was an error uploading the file!', error)
    throw error
  }
}
export const listDocuments = async (page, pageSize, orderAsc, commonSearch, columnFilters = {}) => {
  try {
    let search = ''
    if (commonSearch !== null || commonSearch !== undefined) {
      search = `&commonSearch=${commonSearch}`
    }
    // Filtros das colunas (name, demissaFrom, demissaTo, fileCount); só vão os preenchidos
    Object.entries(columnFilters).forEach(([key, value]) => {
      if (value !== null && value !== undefined && value !== '') {
        search += `&${key}=${encodeURIComponent(value)}`
      }
    })

    let ascObj = ''
    if (orderAsc === true) {
      ascObj = '?orderBy=Cpf'
    } else {
      ascObj = '?orderByDesc=Cpf'
    }
    if (page == null || page == undefined) {
      page = 1
      pageSize = 10
    }

    const response = await apiConfig.sendWithAxios(
      `${apiRoute}trct/listdocuments/paged/${page}/${pageSize}${ascObj}${search}`,
      'GET'
    )
    return response.data
  } catch (error) {
    console.error('There was an error listing the files!', error)
    throw error
  }
}
export const listUploads = async (page, pageSize, orderAsc, commonSearch) => {
  try {
    let search = ''
    if (commonSearch !== null && commonSearch !== undefined && commonSearch !== '') {
      search = `&fileName=${commonSearch}`
    }

    let ascObj = ''
    if (orderAsc === true) {
      ascObj = '?orderBy=createdAt'
    } else {
      ascObj = '?orderByDesc=createdAt'
    }
    if (page == null || page == undefined) {
      page = 1
      pageSize = 10
    }

    const response = await apiConfig.sendWithAxios(
      `${apiRoute}trct/listuploads/page/${page}/${pageSize}${ascObj}${search}`,
      'GET'
    )
    return response.data
  } catch (error) {
    console.error('There was an error listing the files!', error)
    throw error
  }
}


export const getUploadsStatus = async () => {
  try {
    const response = await apiConfig.sendWithAxios(
      `${apiRoute}trct/uploads`,
      'GET'
    )
    return response.data
  } catch (error) {
    console.error('Error at getting uploads status', error)
    throw error
  }

}

// export const searchFilesInFolder = async (folderName, fileName, orderDesc) => {
//   try {
//     const response = await apiConfig.sendWithAxios(
//       `${apiRoute}trct/searchfiles?folderName=${encodeURIComponent(folderName)}&fileName=${encodeURIComponent(fileName)}&orderDesc=${encodeURIComponent(orderDesc)}`,
//       'GET'
//     );
//     return response.data;
//   } catch (error) {
//     console.error("There was an error searching the files!", error);
//     throw error;
//   }
// };

// export const searchDocuments = async (cpf, orderDesc) => {
//   try {
//     const response = await apiConfig.sendWithAxios(
//       `${apiRoute}trct/searchdocuments?fileName=${encodeURIComponent(cpf)}&orderDesc=${encodeURIComponent(orderDesc)}`,
//       'GET'
//     );
//     return response.data;
//   } catch (error) {
//     console.error("There was an error searching the files!", error);
//     throw error;
//   }
// };
// export const searchLogs = async (cpf, orderDesc) => {
//   try {
//     const response = await apiConfig.sendWithAxios(
//       `${apiRoute}trct/searchlogs?cpf=${encodeURIComponent(cpf)}&orderDesc=${encodeURIComponent(orderDesc)}`,
//       'GET'
//     );
//     return response.data;
//   } catch (error) {
//     console.error("There was an error searching the files!", error);
//     throw error;
//   }
// };

export const listChatbotLogs = async (page, pageSize, orderAsc, commonSearch) => {
  try {
    let search = ''
    if (commonSearch !== null && commonSearch !== undefined && commonSearch !== '') {
      search = `&cpf=${commonSearch}`
    }

    let ascObj = ''
    if (orderAsc === true) {
      ascObj = '?orderBy=createdAt'
    } else {
      ascObj = '?orderByDesc=createdAt'
    }
    if (page == null || page == undefined) {
      page = 1
      pageSize = 10
    }

    const response = await apiConfig.sendWithAxios(
      `${apiRoute}trct/log/page/${page}/${pageSize}${ascObj}${search}`,
      'GET'
    )
    return response.data
  } catch (error) {
    console.error('There was an error listing the files!', error)
    throw error
  }
}


/////////////////////////////////////////////////////////////////////
// relatórios HTML
/////////////////////////////////////////////////////////////////////

const relatoriosHtml = `${apiRoute}relatorios-html`

// Autoria e revisão
export const relatorioHtml = async (dashboardId) =>
  await apiConfig.sendJson(`${relatoriosHtml}/${dashboardId}`, 'GET')

export const relatorioHtmlVersao = async (versaoId) =>
  await apiConfig.sendJson(`${relatoriosHtml}/versoes/${versaoId}`, 'GET')

export const relatorioHtmlCriarVersao = async (dashboardId, html) =>
  await apiConfig.sendJson(`${relatoriosHtml}/${dashboardId}/versoes`, 'POST', { html })

export const relatorioHtmlEditarVersao = async (versaoId, html) =>
  await apiConfig.sendJson(`${relatoriosHtml}/versoes/${versaoId}`, 'PUT', { html })

export const relatorioHtmlDescartarVersao = async (versaoId) =>
  await apiConfig.sendJson(`${relatoriosHtml}/versoes/${versaoId}`, 'DELETE')

export const relatorioHtmlAcao = async (versaoId, acao, corpo) =>
  await apiConfig.sendJson(`${relatoriosHtml}/versoes/${versaoId}/${acao}`, 'POST', corpo || {})

export const relatorioHtmlAnalisar = async (html) =>
  await apiConfig.sendJson(`${relatoriosHtml}/analisar`, 'POST', { html })

export const relatorioHtmlSalvarDicionario = async (dashboardId, dicionario) =>
  await apiConfig.sendJson(`${relatoriosHtml}/${dashboardId}/dicionario`, 'PUT', dicionario)

export const relatorioHtmlVincularTemplate = async (dashboardId, templateId) =>
  await apiConfig.sendJson(`${relatoriosHtml}/${dashboardId}/template`, 'PUT', { templateId })

export const templatesHtml = async () => await apiConfig.sendJson(`${relatoriosHtml}/templates`, 'GET')

export const templateHtml = async (id) =>
  await apiConfig.sendJson(`${relatoriosHtml}/templates/${id == null ? 'portal' : id}`, 'GET')

export const templateHtmlSalvar = async (id, template) =>
  await apiConfig.sendJson(`${relatoriosHtml}/templates${id == null ? '' : '/' + id}`, id == null ? 'POST' : 'PUT', template)

export const templateHtmlExcluir = async (id) => await apiConfig.sendJson(`${relatoriosHtml}/templates/${id}`, 'DELETE')

export const templateHtmlDefinirPadrao = async (id) =>
  await apiConfig.sendJson(`${relatoriosHtml}/templates/${id == null ? 'portal' : id}/padrao`, 'POST')

export const templateHtmlPrevia = async (template) => await apiConfig.sendJson(`${relatoriosHtml}/templates/previa`, 'POST', template)

export const relatorioHtmlGuiaClaude = async () =>
  await apiConfig.sendJson(`${relatoriosHtml}/guia-claude`, 'GET')

// Os guias do Claude (relatórios, e-mails, templates) e a versão que a pessoa baixou por último: a tela avisa quando há uma mais nova.
export const guiasClaudeStatus = async () => await apiConfig.sendJson(`${relatoriosHtml}/guias/status`, 'GET')

export const relatorioHtmlExportarDicionario = async (dashboardId) =>
  await apiConfig.sendJson(`${relatoriosHtml}/${dashboardId}/dicionario/exportar`, 'GET')

export const relatorioHtmlModelo = async (dashboardId, parte, tabela) =>
  await apiConfig.sendJson(
    `${relatoriosHtml}/${dashboardId}/modelo/${parte}${tabela ? `?tabela=${encodeURIComponent(tabela)}` : ''}`,
    'GET'
  )

export const relatorioHtmlPrevia = async (dashboardId, versaoId, ambienteId) =>
  await apiConfig.sendJson(`${relatoriosHtml}/${dashboardId}/previa?versao=${versaoId}&ambiente=${ambienteId}`, 'GET')

export const relatorioHtmlPreviaDados = async (dashboardId, ambienteId, consulta) =>
  await apiConfig.sendJson(`${relatoriosHtml}/${dashboardId}/previa/dados?ambiente=${ambienteId}`, 'POST', consulta)

// Aba Dados: prévia de um HTML ainda não salvo, em modo editor
export const relatorioHtmlPreviaRascunho = async (dashboardId, ambienteId, html) =>
  await apiConfig.sendJson(`${relatoriosHtml}/${dashboardId}/previa/html?ambiente=${ambienteId}`, 'POST', { html })

// Visualização
export const relatorioHtmlAbrir =async (dashboardId, ambienteId) =>
  await apiConfig.sendJson(`${relatoriosHtml}/${dashboardId}/${ambienteId}/html`, 'GET')

export const relatorioHtmlDados = async (dashboardId, ambienteId, consulta) =>
  await apiConfig.sendJson(`${relatoriosHtml}/${dashboardId}/${ambienteId}/dados`, 'POST', consulta)

// Seletor de loja: as lojas do relatório no recorte de quem abre (a posição da pessoa nunca vai ao servidor)
export const relatorioHtmlLojas = async (dashboardId, ambienteId) =>
  await apiConfig.sendJson(`${relatoriosHtml}/${dashboardId}/${ambienteId}/lojas`, 'GET')

// Portal.abrir: o relatório abriu WhatsApp, telefone ou um site. O corpo leva só o tipo e um destino curto, nunca a mensagem.
export const relatorioHtmlRegistrarAbertura = async (dashboardId, ambienteId, acao) =>
  await apiConfig.sendJson(`${relatoriosHtml}/${dashboardId}/${ambienteId}/acoes`, 'POST', { tipo: acao.tipo, destino: acao.destino })

// ---------- books de fotos ----------
export const bookLink = async id => await apiConfig.sendJson(`${apiRoute}books/arquivos/${id}/link`, 'GET')

// ---------- seletor de loja (guardado no dashboard, vale para todas as versões) ----------
export const relatorioHtmlSeletorLoja = async dashboardId =>
  await apiConfig.sendJson(`${relatoriosHtml}/${dashboardId}/seletor-loja`, 'GET')

export const relatorioHtmlSalvarSeletorLoja = async (dashboardId, seletor) =>
  await apiConfig.sendJson(`${relatoriosHtml}/${dashboardId}/seletor-loja`, 'PUT', { seletor })

export const relatorioHtmlDesligarSeletorLoja = async dashboardId =>
  await apiConfig.sendJson(`${relatoriosHtml}/${dashboardId}/seletor-loja`, 'DELETE')

// ---------- disparos de e-mail dos relatórios HTML ----------
const disparosEmail = dashboardId => `${relatoriosHtml}/${dashboardId}/disparos`

export const disparosEmailOpcoes = async dashboardId =>
  await apiConfig.sendJson(`${disparosEmail(dashboardId)}/opcoes`, 'GET')

export const disparosEmailLista = async dashboardId =>
  await apiConfig.sendJson(disparosEmail(dashboardId), 'GET')

export const disparosEmailSalvar = async (dashboardId, id, dados) =>
  id
    ? await apiConfig.sendJson(`${disparosEmail(dashboardId)}/${id}`, 'PUT', dados)
    : await apiConfig.sendJson(disparosEmail(dashboardId), 'POST', dados)

export const disparosEmailExcluir = async (dashboardId, id) =>
  await apiConfig.sendJson(`${disparosEmail(dashboardId)}/${id}`, 'DELETE')

export const disparosEmailAtivar = async (dashboardId, id, ativo) =>
  await apiConfig.sendJson(`${disparosEmail(dashboardId)}/${id}/ativar`, 'POST', { ativo })

export const disparosEmailAnalisar = async (dashboardId, html) =>
  await apiConfig.sendJson(`${disparosEmail(dashboardId)}/analisar`, 'POST', { html })

export const disparosEmailModelo = async dashboardId =>
  await apiConfig.sendJson(`${disparosEmail(dashboardId)}/modelo`, 'GET')

export const disparosEmailGuia = async dashboardId =>
  await apiConfig.sendJson(`${disparosEmail(dashboardId)}/guia-claude`, 'GET')

export const disparosEmailPrevia = async (dashboardId, rascunho) =>
  await apiConfig.sendJson(`${disparosEmail(dashboardId)}/previa`, 'POST', rascunho)

export const disparosEmailTeste = async (dashboardId, id) =>
  await apiConfig.sendJson(`${disparosEmail(dashboardId)}/${id}/teste`, 'POST', {})

export const disparosEmailHistorico = async (dashboardId, id) =>
  await apiConfig.sendJson(`${disparosEmail(dashboardId)}/${id}/historico`, 'GET')

// ---------- oneflow (Cortex Agents do Snowflake) ----------
const oneflow = `${apiRoute}oneflow`

export const oneflowConversa = async (dashboardId, ambienteId) =>
  await apiConfig.sendJson(`${oneflow}/${dashboardId}/${ambienteId}/conversa`, 'GET')

export const oneflowPerguntar = async (dashboardId, ambienteId, pergunta) =>
  await apiConfig.sendJson(`${oneflow}/${dashboardId}/${ambienteId}/mensagem`, 'POST', { pergunta })

export const oneflowTarefa = async (tarefaId) => await apiConfig.sendJson(`${oneflow}/tarefas/${tarefaId}`, 'GET')

export const oneflowNovaConversa = async (dashboardId, ambienteId) =>
  await apiConfig.sendJson(`${oneflow}/${dashboardId}/${ambienteId}/conversa`, 'DELETE')

export const oneflowStatus = async () => await apiConfig.sendJson(`${oneflow}/status`, 'GET')

export const oneflowLiberacoes = async (agenteId) => await apiConfig.sendJson(`${oneflow}/agentes/${agenteId}/liberacoes`, 'GET')

export const oneflowLiberar = async (agenteId, usuarioId, limiteMensal) =>
  await apiConfig.sendJson(`${oneflow}/agentes/${agenteId}/liberacoes/${usuarioId}`, 'PUT', { limiteMensal })

export const oneflowTirarLiberacao = async (agenteId, usuarioId) =>
  await apiConfig.sendJson(`${oneflow}/agentes/${agenteId}/liberacoes/${usuarioId}`, 'DELETE')

export const oneflowConsumo = async (agenteId, ano, mes) =>
  await apiConfig.sendJson(`${oneflow}/agentes/${agenteId}/consumo?ano=${ano}&mes=${mes}`, 'GET')

// ---------- novo portal: marcas, preferências e favoritos ----------
const novoPortal = `${apiRoute}novo-portal`

export const novoPortalContexto = async () => await apiConfig.sendJson(`${novoPortal}/contexto`, 'GET')

export const novoPortalPreferencia = async (chave, valor) =>
  await apiConfig.sendJson(`${novoPortal}/preferencias/${encodeURIComponent(chave)}`, 'PUT', { valor })

export const novoPortalFavoritar = async (dashboardId, ambienteId) =>
  await apiConfig.sendJson(`${novoPortal}/favoritos/${dashboardId}/${ambienteId}`, 'PUT')

export const novoPortalDesfavoritar = async (dashboardId, ambienteId) =>
  await apiConfig.sendJson(`${novoPortal}/favoritos/${dashboardId}/${ambienteId}`, 'DELETE')

export const novoPortalMarcas = async () => await apiConfig.sendJson(`${novoPortal}/marcas`, 'GET')

export const novoPortalSalvarMarca = async (marca) =>
  await apiConfig.sendJson(`${novoPortal}/marcas${marca.id ? '/' + marca.id : ''}`, marca.id ? 'PUT' : 'POST', marca)

export const novoPortalExcluirMarca = async (id) => await apiConfig.sendJson(`${novoPortal}/marcas/${id}`, 'DELETE')

export const novoPortalVincularAmbientes = async (id, ambientes) =>
  await apiConfig.sendJson(`${novoPortal}/marcas/${id}/ambientes`, 'PUT', { ambientes })

export const novoPortalArvore = async () => await apiConfig.sendJson(`${novoPortal}/arvore`, 'GET')
export const quandoGravar = fn => apiConfig.quandoGravar(fn)

export const novoPortalSuaVisao = async (dashboardId, ambienteId) =>
  await apiConfig.sendJson(`${novoPortal}/sua-visao/${dashboardId}/${ambienteId}`, 'GET')

export const novoPortalInicio = async () => await apiConfig.sendJson(`${novoPortal}/inicio`, 'GET')

export const novoPortalConferirLink = async (link) =>
  await apiConfig.sendJson(`${novoPortal}/gestao/conferir-link?link=${encodeURIComponent(link)}`, 'GET')

export const novoPortalVincularDashboard = async (dashboardId, corpo) =>
  await apiConfig.sendJson(`${novoPortal}/gestao/dashboards/${dashboardId}/ambientes`, 'POST', corpo)

export const novoPortalPreencherDatasets = async (depoisDe) =>
  await apiConfig.sendJson(`${novoPortal}/gestao/dashboards/preencher-datasets${depoisDe ? `?depoisDe=${depoisDe}` : ''}`, 'POST')

export const novoPortalCatalogo = async () => await apiConfig.sendJson(`${novoPortal}/gestao/catalogo`, 'GET')

export const novoPortalGruposDosAmbientes = async (ids) =>
  await apiConfig.sendJson(`${novoPortal}/gestao/grupos?ambientes=${ids.join(',')}`, 'GET')

export const novoPortalAtivarAmbiente = async (id, ativo) =>
  await apiConfig.sendJson(`${novoPortal}/gestao/ambientes/${id}/ativo`, 'PUT', { ativo })

export const novoPortalGestaoAmbientes = async () => await apiConfig.sendJson(`${novoPortal}/gestao/ambientes`, 'GET')

export const novoPortalGestaoAmbiente = async (id) => await apiConfig.sendJson(`${novoPortal}/gestao/ambientes/${id}`, 'GET')

export const novoPortalMarcaDoAmbiente = async (id, marcaId) =>
  await apiConfig.sendJson(`${novoPortal}/gestao/ambientes/${id}/marca`, 'PUT', { marcaId })

export const novoPortalIndicador = async (dashboardId, ambienteId) =>
  await apiConfig.sendJson(`${novoPortal}/indicador/${dashboardId}/${ambienteId}`, 'GET')

export const novoPortalTestarIndicador = async (dashboardId, corpo) =>
  await apiConfig.sendJson(`${novoPortal}/gestao/dashboards/${dashboardId}/indicador/testar`, 'POST', corpo)

export const novoPortalConfigurarIndicador = async (dashboardId, corpo) =>
  await apiConfig.sendJson(`${novoPortal}/gestao/dashboards/${dashboardId}/indicador`, 'PUT', corpo)

export const novoPortalAtualizarDados = async (dashboardId, ambienteId) =>
  await apiConfig.sendJson(`${novoPortal}/dashboards/${dashboardId}/${ambienteId}/atualizar-dados`, 'POST')

export const novoPortalRegras = async () => await apiConfig.sendJson(`${novoPortal}/gestao/regras`, 'GET')

export const novoPortalRegra = async (id) => await apiConfig.sendJson(`${novoPortal}/gestao/regras/${id}`, 'GET')

export const novoPortalImportarItens = async (id, corpo) =>
  await apiConfig.sendJson(`${novoPortal}/gestao/regras/${id}/importar`, 'POST', corpo)

/** O que acontece com quem tem acesso ao dashboard e nenhum item na regra: veTudo verdadeiro vê tudo, falso não vê nada. */
export const novoPortalSemValor = async (id, veTudo) =>
  await apiConfig.sendJson(`${novoPortal}/gestao/regras/${id}/sem-valor`, 'PUT', { veTudo })

export const novoPortalPessoas = async (filtros) => {
  const q = new URLSearchParams(Object.entries(filtros).filter(([, v]) => v !== '' && v != null)).toString()
  return await apiConfig.sendJson(`${novoPortal}/gestao/pessoas${q ? `?${q}` : ''}`, 'GET')
}

export const novoPortalPessoa = async (id) => await apiConfig.sendJson(`${novoPortal}/gestao/pessoas/${id}`, 'GET')

/** Duplica o dashboard com dicionário, seletor, filtros, vínculos, versões do HTML e disparos (pausados). */
export const novoPortalDuplicarDashboard = async (id, corpo) =>
  await apiConfig.sendJson(`${novoPortal}/gestao/dashboards/${id}/duplicar`, 'POST', corpo)

export const novoPortalEquipes = async () => await apiConfig.sendJson(`${novoPortal}/gestao/equipes`, 'GET')

export const novoPortalEquipe = async (id) => await apiConfig.sendJson(`${novoPortal}/gestao/equipes/${id}`, 'GET')

export const novoPortalVinculos = async () => await apiConfig.sendJson(`${novoPortal}/gestao/vinculos`, 'GET')

export const novoPortalDarAcesso = async (corpo) => await apiConfig.sendJson(`${novoPortal}/gestao/acessos`, 'POST', corpo)

// Solicitações ao time de BI
const solicitacoesApi = `${apiRoute}solicitacoes`

export const solicitacoesListar = async (todas, finalizadosDias, compartilhadas) =>
  await apiConfig.sendJson(`${solicitacoesApi}?todas=${todas ? 'true' : 'false'}${finalizadosDias ? `&finalizadosDias=${finalizadosDias}` : ''}${compartilhadas ? '&compartilhadas=true' : ''}`, 'GET')

// Compartilhar: quem acompanha a solicitação (vê, conversa e anexa).
export const solicitacaoAcompanhantes = async (id) => await apiConfig.sendJson(`${solicitacoesApi}/${id}/acompanhantes`, 'GET')

export const solicitacaoIncluirAcompanhantes = async (id, pessoaIds) =>
  await apiConfig.sendJson(`${solicitacoesApi}/${id}/acompanhantes`, 'POST', { pessoaIds })

export const solicitacaoTirarAcompanhante = async (id, pessoaId) =>
  await apiConfig.sendJson(`${solicitacoesApi}/${id}/acompanhantes/${pessoaId}`, 'DELETE')

export const solicitacoesCriar = async (corpo) => await apiConfig.sendJson(solicitacoesApi, 'POST', corpo)

export const solicitacaoDetalhe = async (id) => await apiConfig.sendJson(`${solicitacoesApi}/${id}`, 'GET')

export const solicitacaoHistorico = async (id) => await apiConfig.sendJson(`${solicitacoesApi}/${id}/historico`, 'GET')

export const solicitacaoMensagens = async (id) => await apiConfig.sendJson(`${solicitacoesApi}/${id}/mensagens`, 'GET')

export const solicitacaoEnviarMensagem = async (id, mensagem, interna) =>
  await apiConfig.sendJson(`${solicitacoesApi}/${id}/mensagens`, 'POST', { mensagem, interna: !!interna })

export const solicitacaoAnexos = async (id) => await apiConfig.sendJson(`${solicitacoesApi}/${id}/anexos`, 'GET')

export const solicitacaoEnviarAnexo = async (id, arquivo) => {
  const corpo = new FormData()
  corpo.append('arquivo', arquivo)
  return await apiConfig.sendJson(`${solicitacoesApi}/${id}/anexos`, 'POST', corpo)
}

export const solicitacaoLinkAnexo = async (id, anexoId, inline) =>
  await apiConfig.sendJson(`${solicitacoesApi}/${id}/anexos/${anexoId}/link?inline=${inline ? 'true' : 'false'}`, 'GET')

export const solicitacaoRemoverAnexo = async (id, anexoId) =>
  await apiConfig.sendJson(`${solicitacoesApi}/${id}/anexos/${anexoId}`, 'DELETE')

export const solicitacoesAmbientes = async () => await apiConfig.sendJson(`${solicitacoesApi}/ambientes`, 'GET')

export const solicitacoesBuscar = async (tipo, q) =>
  await apiConfig.sendJson(`${solicitacoesApi}/busca/${tipo}?q=${encodeURIComponent(q)}`, 'GET')

export const solicitacoesArvore = async () => await apiConfig.sendJson(`${solicitacoesApi}/arvore`, 'GET')

export const solicitacoesConfig = async () => await apiConfig.sendJson(`${solicitacoesApi}/config`, 'GET')

export const solicitacoesConferirCadastro = async (email, cpf) =>
  await apiConfig.sendJson(`${solicitacoesApi}/conferir-cadastro`, 'POST', { email, cpf })

// Quem atende: quem tem a claim gestao_solicitacoes no AuthManager. Não há o que cadastrar no portal.
export const solicitacoesAtendentes = async () => await apiConfig.sendJson(`${solicitacoesApi}/atendentes`, 'GET')

// A fila de quem atende: os pedidos de desenvolvimento atribuídos a ele, na ordem que ele arrumou. Salvar avisa quem pediu se o lugar mudou.
export const solicitacoesMinhaFila = async () => await apiConfig.sendJson(`${solicitacoesApi}/minha-fila`, 'GET')

export const solicitacoesArrumarMinhaFila = async (ids) => await apiConfig.sendJson(`${solicitacoesApi}/minha-fila`, 'PUT', { ids })

export const solicitacaoMudarStatus = async (id, status, motivo) =>
  await apiConfig.sendJson(`${solicitacoesApi}/${id}/status`, 'PUT', { status, motivo: motivo || null })

export const solicitacaoResponsavel = async (id, responsavelId) =>
  await apiConfig.sendJson(`${solicitacoesApi}/${id}/responsavel`, 'PUT', { responsavelId: responsavelId || null })

export const solicitacaoAceitar = async (id) => await apiConfig.sendJson(`${solicitacoesApi}/${id}/aceitar`, 'POST')

export const solicitacaoRecusar = async (id, motivo) =>
  await apiConfig.sendJson(`${solicitacoesApi}/${id}/recusar`, 'POST', { motivo })

export const solicitacaoReabrir = async (id, motivo) =>
  await apiConfig.sendJson(`${solicitacoesApi}/${id}/reabrir`, 'POST', { motivo: motivo || null })

export const solicitacaoPlano = async (id) => await apiConfig.sendJson(`${solicitacoesApi}/${id}/processar`, 'GET')

export const solicitacaoProcessar = async (id, corpo) => await apiConfig.sendJson(`${solicitacoesApi}/${id}/processar`, 'POST', corpo)

export const solicitacaoCriarLogin = async (id, corpo) => await apiConfig.sendJson(`${solicitacoesApi}/${id}/processar/login`, 'POST', corpo)

export const solicitacaoTriagem = async (id, corpo) => await apiConfig.sendJson(`${solicitacoesApi}/${id}/triagem`, 'PUT', corpo)

export const solicitacaoBloquear = async (id, bloqueado, motivo) =>
  await apiConfig.sendJson(`${solicitacoesApi}/${id}/bloqueio`, 'PUT', { bloqueado: !!bloqueado, motivo: motivo || null })

export const solicitacoesBuscarConversas = async (q, todas, compartilhadas) =>
  await apiConfig.sendJson(`${solicitacoesApi}/busca-mensagens?q=${encodeURIComponent(q)}&todas=${todas ? 'true' : 'false'}${compartilhadas ? '&compartilhadas=true' : ''}`, 'GET')

// A foto que o relatório HTML pediu com Portal.imagem: o servidor busca no host liberado e devolve os bytes.
export const relatorioHtmlImagem = async url =>
  await apiConfig.sendBinario(`${relatoriosHtml}/imagem?url=${encodeURIComponent(url)}`)

// O guia para o Claude criar o arquivo .json de um template (a tela de templates importa esse arquivo).
export const templatesHtmlGuiaClaude = async () => await apiConfig.sendJson(`${relatoriosHtml}/templates/guia-claude`, 'GET')

// Os relatórios HTML que a tela de templates pode abrir com o template em edição, e a prévia em si.
export const templatesHtmlRelatoriosParaPrevia = async () => await apiConfig.sendJson(`${relatoriosHtml}/templates/relatorios-para-previa`, 'GET')

export const templateHtmlPreviaRelatorio = async (dashboardId, ambienteId, template) =>
  await apiConfig.sendJson(`${relatoriosHtml}/templates/previa-relatorio?dashboardId=${dashboardId}&ambiente=${ambienteId}`, 'POST', template)
